import _debounce from 'lodash/debounce';
import template from './control-worked-hours.html';

class ControlWorkedHoursComponent {
  constructor(
    $log,
    moment,
    SummaryService
  ) {
    'ngInject';
    this.$log = $log;
    this.moment = moment;
    this.SummaryService = SummaryService;

    this._employees = [];
    this.loadPageCallbackWithDebounce = {};
    this.dataTable = {};
    this.filterState = {
      dateFrom: this.moment().subtract(7, 'days').toDate(),
      dateTo: this.moment().toDate(),
      selectedEmployee: 'ALL'
    };
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.employees) {
      angular.copy(this.employees, this._employees);
    }
  }

  isManager() {
    return this.me.roleName === 'MANAGER';
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page = 1, pageSize = 0) {
    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    const filterParams = this.getFilterParams();
    if (this.isManager()) {
      return this.SummaryService.getRealizedActivities({
        ...filterParams,
        offset,
        limit: pageSize
      }).then(result => ({
        results: result.data,
        totalResultCount: result.total
      }));
    }

    return this.SummaryService.getMyRealizedActivities({
      ...filterParams,
      offset,
      limit: pageSize
    }).then(result => ({
      results: result.data,
      totalResultCount: result.total
    }));
  }

  setFilter(filterForm) {
    if (!filterForm.$valid) {
      return false;
    }

    this.dateFrom = this.filterState.dateFrom;
    this.dateTo = this.filterState.dateTo;
    this.dataTable.mdtPaginationHelper.getFirstPage();
  }

  getFilterParams() {
    const filterParams = {
      dateFrom: this.moment(this.filterState.dateFrom).format('YYYY-MM-DD'),
      dateTo: this.moment(this.filterState.dateTo).format('YYYY-MM-DD')
    };
    if (this.filterState.selectedEmployee !== 'ALL') {
      filterParams.employeeIds = this.filterState.selectedEmployee;
    }

    return filterParams;
  }
}

export const ControlWorkedHours = {
  bindings: {
    me: '<',
    employees: '<'
  },
  template,
  controller: ControlWorkedHoursComponent
};
